<section class="icon-section">
  @if (note.creator | user : { select: ['avatar'] } | async; as user) {
  <span class="user-assign m-l-8">
    @if ( user?.avatar | fileUrl : { height: 64, width: 64 } | async; as src) {
    <img [ngSrc]="src" height="26" width="26" />
    } @else {
    <fa-icon class="top-icon" [icon]="faUser"></fa-icon>
    }
    <ng-template #icon>
      <fa-icon class="top-icon" [icon]="faUser"></fa-icon>
    </ng-template>
  </span>
  }
</section>
<section class="content">
  <div class="remark">
    <p class="m-b-8">{{ note.remark }}</p>
    <div class="attachments">
      @for (attachment of note.attachments; track attachment) {
      <div class="attachment m-t-8">
        @if (attachment | file | async; as file) {
        <a
          [href]="file.src | fileUrl : { format, quality, timeout } | async"
          class="file-icon"
          ><fa-icon [icon]="faFile"></fa-icon
        ></a>
        <a
          [href]="file.src | fileUrl : { format, quality, timeout } | async"
          class="info t-tiny t-ellipsis"
        >
          <p class="t-ellipsis">{{ file.name }}</p>
          <p class="c-soft">{{ file.size | fileSize }}</p>
        </a>
        <a
          class="download-icon"
          [href]="file.src | fileUrl : { format, quality, timeout } | async"
          ><fa-icon [icon]="faDownload"></fa-icon
        ></a>
        }
      </div>
      }
    </div>
  </div>
  <div class="author">
    @if ( note.creator | user : { select: ['firstName', 'lastName'] } | async;
    as user ) {
    <p class="t-small t-medium">
      {{ user.firstName + ' ' + user.lastName }}
    </p>
    }
    <p class="t-small c-soft">
      {{ note.updatedAt | date : 'MMM d, y, h:mm a' }}
    </p>
  </div>
</section>
